import Dto from "../../Dto";

class WriteAuthorization extends Dto {

  constructor(sysAccountId = null, sysUserGroupId = null, sysUserId = null, privileges = null) {
    super('po2\\service\\system\\dto\\WriteAuthorization');
    this.sysAccountId = sysAccountId;
    this.sysUserGroupId = sysUserGroupId;
    this.sysUserId = sysUserId;
    this.privileges = privileges;
  }

  getSysAccountId() {
    return this.sysAccountId;
  }

  setSysAccountId(sysAccountId) {
    this.sysAccountId = sysAccountId;
  }

  getSysUserGroupId() {
    return this.sysUserGroupId;
  }

  setSysUserGroupId(sysUserGroupId) {
    this.sysUserGroupId = sysUserGroupId;
  }

  getSysUserId() {
    return this.sysUserId;
  }

  setSysUserId(sysUserId) {
    this.sysUserId = sysUserId;
  }

  getPrivileges() {
    return this.privileges;
  }

  setPrivileges(privileges) {
    this.privileges = privileges;
  }
}

export default WriteAuthorization;